import { Injectable } from '@angular/core';
import { ResponsiveService } from './responsive.service';
import { ScreenSizeType } from '@models/responsive';

@Injectable({ providedIn: 'root' })
export class CssVarService {
    readonly OPS_TABLE_ROW = '--ops-table-row-height';

    tableRow = this.OPS_TABLE_ROW;

    constructor(private responsive: ResponsiveService) {}

    public get tableRowGap() {
        return Number(this.getGlobalVar('--ops-table-gap').replace('px', ''));
    }

    public get tableRowHeightAlarm() {
        return Number(this.getGlobalVar(`${this.tableRow}-alarm`).replace('px', ''));
    }

    public get tableRowHeightChannel() {
        let tableRow =
            this.responsive.screenSize === ScreenSizeType.XSmall
                ? `${this.tableRow}-channel-${ScreenSizeType.XSmall}`
                : `${this.tableRow}-channel`;
        return Number(this.getGlobalVar(tableRow).replace('px', ''));
    }

    private getGlobalVar(varName: string): string {
        return getComputedStyle(document.documentElement).getPropertyValue(varName);
    }
}

export enum TableRowType {
    CHAENNEL = '-channel',
    ALARM = '-alarm',
}
